const tone = new Audio("/message-tone.mp3");

export const playMessageTone = () => {
  tone.currentTime = 0;
  // Browsers reject playback until the user has interacted with the page.
  tone.play().catch(() => undefined);
};
